import { FormattedMessage } from "react-intl";

export default function ManageFundingDepositDetails(props: any) {
  const {
    firstTimeMinimumDeposit,
    firstTimeMinimumDepositEnabled,
    firstTimeMinimumDepositComplete,
  } = props.user;
  const showDetails =
    firstTimeMinimumDepositEnabled && !firstTimeMinimumDepositComplete;
  return (
    <div className="manage-funding-deposit-details">
      {showDetails && (
        <div className="manage-funding-deposit-details__amount">
          <FormattedMessage id="cashier-minimum-deposit-amount" />
          {": "}
          {firstTimeMinimumDeposit}
        </div>
      )}
    </div>
  );
}
